import { useMutation } from '@apollo/client';
import { faLock, faTrash, faPlus, faTrashCan, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Popover, Select, Space, Table, notification } from 'antd';
import { useEffect, useState } from 'react';
import { ARCHIVE_PROPERTY } from '@src/util/mutation/properties.mutation';
import { ArchiveConfirmationModal } from '@src/pages/setting/dataFields/modal/archeiveConfirmation.modal';
import { useDispatch } from 'react-redux';
import { setEditPropertyId } from '@src/middleware/redux/reducers/createField.reducer';
import { Loader } from '@src/components/loader';
import { moveToGroup } from '@src/middleware/redux/reducers/group.reducer';
import { BulkArchiveConfirmationModal } from '@src/pages/setting/dataFields/modal/bulkArchiveConfirmation.modal';
import { MoveGroupModal } from '@src/pages/setting/dataFields/modal/moveGroup.modal';
import { archiveTaskInLibraryMutation } from '@src/util/mutation/taskInLibrary.mutation';
import { AssociateSitesModal } from './associateSites.modal';


export const TaskLibraryGrid = ({propertyList,
  setFieldModal, taskListRefetch,
  refetch, propertyListLoading, groupList, setTaskToBeEdit, taskListLoading, isLegacyTenant=false}) => {

  
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [hoveredRow, setHoveredRow] = useState(null);
  

  const [currentPage, setCurrentPage] = useState(Number(localStorage.getItem("currPropPage")) || 1);
  const handleChange = (pagination, filters, sorter) => {
    setCurrentPage(pagination.current)
    localStorage.setItem("currPropPage", pagination.current)
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };


  // property archive mutation
  const [archiveTask, {loading, error}] = useMutation(archiveTaskInLibraryMutation);
  const [archiveConfirmationModal, setArchiveConfirmationModal] = useState(false);
  const [bulkArchiveConfirmationModal, setBulkArchiveConfirmation] = useState(false);
  const [archivedId, setArchivedId] = useState(null);

  const [api, contextHolder] = notification.useNotification();


  const [moreOption, setMoreoption]=useState(false);
  const [propertyName, setPropertyName] = useState("");

  const [moveGroup, setMoveGroup] = useState(false);

  const [associateSitesTask, setAssociateSitesTask] = useState(null);

  const HandelArcheiveTask = async() => {
    try{
      if(archivedId){

        await archiveTask({
          variables:{
              id: archivedId, 
              isArchived: true
          }
        });
        setArchiveConfirmationModal(false);

        await taskListRefetch();
        
        api.success({
          message: `Task was archived`,
          placement:"top",
          className: 'notification-without-close',
        });
        
      }

    }catch(err){
      throw new Error(err.message);
    }
  }


  const dispatch = useDispatch();


  

  const columns = [
    {
      title: 'Name',
      dataIndex: 'label',
      key: 'label',
      sorter: (a, b) => a.label.localeCompare(b.label),
      sortOrder: sortedInfo.columnKey === 'label' ? sortedInfo.order : null,
      // width: '300px',
      render: (_, record) => {
        const showActions = hoveredRow === record._id;
        const maxLength = 60; // Adjust this value based on your needs
        const shouldTruncate = showActions && record?.label?.length > maxLength;
        
        const needsSiteAssociation = !isLegacyTenant && !(record?.siteIds?.length > 0);

        return (
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>

            <Popover
              overlayClassName='settingGridPopover'
              content={
                <div>
                  <div className='popover-record-title' >{record.label}</div>
                  <span>{record.description}</span>
                </div>
              }
              placement='topLeft'
            >
              <div className='record-title' style={{width: '100%'}}>
                {shouldTruncate
                  ? `${record.label.substring(0, maxLength)}...`
                  : record.label
                }
              </div>
            </Popover>

            {needsSiteAssociation &&
              <Popover content="Acknowledgement required — associate with sites">
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  style={{color: '#faad14', cursor: 'pointer', marginLeft: '8px'}}
                  onClick={() => setAssociateSitesTask(record)}
                />
              </Popover>
            }

          
            <div style={showActions && selectedRowKeys?.length===0?{ display:'flex', justifyContent:'flex-end' ,alignItems:'center', columnGap:'10px', visibility:'visible'}:{visibility:'hidden', display:'flex', justifyContent:'flex-end' ,alignItems:'center', columnGap:'10px'}}>
              
              <button  style={{marginLeft:'10%'}} className={"sm-btn"} type="link" onClick={() => { setFieldModal(true); setTaskToBeEdit(record?._id);}}>
                Edit
              </button>

              <button className={"sm-btn"}  type="link" onClick={() => {setArchiveConfirmationModal(true);  setArchivedId(record._id); }}>
                  Archive
              </button>

            </div>
          
        </div>
        );
      },

    },
    ...(isLegacyTenant ? [{
      title: 'Group',
      dataIndex: 'groupName',
      key: 'groupName',
      sorter: (a, b) => a.groupName.localeCompare(b.groupName),
      sortOrder: sortedInfo.columnKey === 'groupName' ? sortedInfo.order : null,

    }] : []),
    ...(!isLegacyTenant ? [{
      title: 'Sites',
      dataIndex: 'siteDetails',
      key: 'siteDetails',
      render: (_, record) => record?.siteDetails?.length>0
        ? record.siteDetails.map((site)=>site?.sitename).join(', ')
        : '-',
    }] : []),
    {
      title: 'Created BY',
      dataIndex: 'createdBy',
      key: 'createdBy',
      sorter: (a, b) => a.createdBy - b.createdBy,
      sortOrder: sortedInfo.columnKey === 'createdBy' ? sortedInfo.order : null,
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
  ];
  
  const [selectedRowKeys, setSelectedRowKeys]=useState([]);


  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  
  
  const handelBulkGroup = () => {
    // handle edit action for the selected record
    dispatch(moveToGroup(propertyList.filter((property)=> selectedRowKeys.includes(property.key))));
    setMoveGroup(true)

  };

  const rowClassName = (record) => {
    return record._id === hoveredRow ? 'hovered-row' : '';
  };
  
  const handleRowMouseEnter = (record) => {
    setHoveredRow(record._id);
  };


  const handleRowMouseLeave = () => {
    setHoveredRow(null);
    setMoreoption(false);
  };


  const customHeader =(

      <div className='table-footer' id="selection-options"

      >
        

        {selectedRowKeys?.length>0 &&
        <>
            <small className='small-text'> {selectedRowKeys?.length} selected</small>

            {isLegacyTenant &&
            <div  onClick={handelBulkGroup}>
                <FontAwesomeIcon icon={faPlus} style={{marginRight:'5px'}}/> <span>Add to group</span>
            </div>
            }

            <div onClick={()=>setBulkArchiveConfirmation(true)}>
                <FontAwesomeIcon icon={faTrashCan} style={{marginRight:'5px'}}/> <span>Archive</span>
            </div>

            <div  >
                 <span>Assign Users & Team</span> <FontAwesomeIcon icon={faLock} style={{marginLeft:'5px'}}/>
            </div>

        </>
    }
      </div>
    )

    const handlePaginationChange = (pagination) => {
      setCurrentPage(pagination.current);
    };
    
    
  return (
    <div 
      className='setting-grid'
    >
      
      <>
        {contextHolder}
        <Table 
          title={selectedRowKeys?.length>0 ? () => customHeader : null}
          className='moveGroupTable curvedTable'
          columns={columns} 
          dataSource={propertyList} 
          // rowSelection={rowSelection}
          onChange={handleChange} 
          loading={taskListLoading}
          onRow={(record) => ({
            onMouseEnter: () => handleRowMouseEnter(record),
            onMouseLeave: () => handleRowMouseLeave(),
          })}
          rowClassName={rowClassName}
          pagination={{     
            current: currentPage || 1, 
            // pageSize: 10, // Set your desired page size
            onChange: handlePaginationChange,
          }}
        />

        <ArchiveConfirmationModal 
          visible={archiveConfirmationModal}
          propertyName={propertyName}
          onClose={()=>setArchiveConfirmationModal(false)}
          ArcheivePropertyGrid={HandelArcheiveTask}
          loading={loading}
          entity={"Task"}
          
        />

        {bulkArchiveConfirmationModal &&
          <BulkArchiveConfirmationModal
            visible={bulkArchiveConfirmationModal}
            properties={selectedRowKeys?.length}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
            refreshAll = {
              async() => {
                await taskListRefetch();
                await refetch();
              }
            }
            onClose={()=>setBulkArchiveConfirmation(false)}
            HandelArcheiveTask={HandelArcheiveTask}
            loading={loading}
          />
        }


        {
            moveGroup ?

            <MoveGroupModal
            groupList={groupList}
            visible={moveGroup}
            taskListRefetch={taskListRefetch}
            setSelectedRowKeys={setSelectedRowKeys}
            onClose={()=>setMoveGroup(false)}
            />
            : null
        }

        {associateSitesTask &&
          <AssociateSitesModal
            visible={!!associateSitesTask}
            task={associateSitesTask}
            taskListRefetch={taskListRefetch}
            onClose={()=>setAssociateSitesTask(null)}
          />
        }

      </>

    </div>
  );
};
